// extracted by mini-css-extract-plugin
export default {"topic":"Topics_topic__MPjKX","topic_p":"Topics_topic_p__xlT+r","topics":"Topics_topics__0Y4ke","techName":"Topics_techName__zex+8"};